export default {"src":"/_next/static/media/people_search.08543e38.svg","height":844,"width":1114};